import { Badge } from '@mantine/core';
import { statusLabel } from '../format';

/**
 * Draft, live or archived, in the same colours wherever it appears.
 *
 * It is its own file because the list and the editor both show it, and a status that reads one way
 * on one screen and another way on the next is how an editor loses track of what is public.
 */
export function StatusBadge({ status }: { status: string }) {
  const live = status === 'published';
  return (
    <Badge
      className="interaction-status"
      size="md"
      radius="sm"
      variant="light"
      color={live ? 'sage' : 'gray'}
      leftSection={
        <span className={`status-dot ${live ? 'status-dot-live' : ''}`} aria-hidden="true" />
      }
    >
      {statusLabel(status)}
    </Badge>
  );
}
